import { ColunaExportacao } from './coluna-exportacao';
import { Dictionary } from 'lodash';

export class DadosParaExportacaoBasicoDto {
    constructor(public colunas: Array<ColunaExportacao>, public dadosTabela: Array<Dictionary<string>>, public titulo: string) {}
}
